import { createFileRoute } from '@tanstack/react-router'

import { PaymentOriginScreen } from './-components/payment-origin-screen.tsx'

export const Route = createFileRoute('/business-performance/payment-origin')({
  component: PaymentOriginScreen
})
